<template>
  <b-modal
    v-model="show"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
  >
    <template slot="modal-title">
      {{ $t(`${tForm}.title`) }}
    </template>
    <p v-html="description" />
    <form
      :data-vv-scope="formName"
      class="form-horizontal"
      @submit.prevent="onSubmit"
    >
      <div
        :class="{'has-warning': errors.has(`${formName}.confirmation`)}"
        class="form-group"
      >
        <label class="control-label">{{ $t(`${tForm}.confirmation`) }}</label>
        <input
          ref="rconfirm"
          v-model="confirmation"
          v-validate="'required'"
          :data-vv-as="$t(`${tForm}.confirmation`).toLowerCase()"
          :data-vv-scope="formName"
          :placeholder="$t(`${tForm}.confirmation_placeholder`)"
          class="form-control"
          type="text"
          name="confirmation"
        >
        <span
          v-if="errors.has(`${formName}.confirmation`)"
          class="invalid-feedback"
          v-html="errors.first(`${formName}.confirmation`)"
        />
      </div>
    </form>
    <div
      slot="modal-footer"
      class="w-100 text-right"
    >
      <button
        :class="{'disabled': submit}"
        type="button"
        class="btn ml-auto btn-primary btn-labeled btn-labeled-left"
        @click="onSubmit"
      >
        <b><i class="icon-checkmark4" /></b>
        {{ $t(`${tForm}.btn_submit`) }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import {events} from '.';
import catchDispatch, {catchDispatchErrorMsg} from "../catchDispatch";

export default {
  inject: ['$validator'],
  data() {
    return {
      tForm: 'widget.otp',
      formName: 'widget.otp',
      show: false,
      submit: false,
      confirmation: '',
      name: '',
      callback: () => ({}),
    };
  },
  computed: {
    description() {
      const name = this.$t(this.name);
      return this.$t(`${this.tForm}.description`, {name});
    },
  },
  created() {
    events.$on('open', this.open);
  },
  methods: {
    open({name = '', callback = () => ({})}) {
      this.submit = false;
      this.confirmation = '';
      this.name = name;
      this.callback = callback;
      this.show = true;
      const focusTimer = setInterval(() => {
        const {rconfirm} = this.$refs;
        if (rconfirm === undefined) return;
        rconfirm.focus();
        clearInterval(focusTimer);
      });
    },
    async onSubmit() {
      if (this.submit) return false;
      this.submit = true;

      this.errors.clear(this.formName);

      const r = await this.$validator.validateAll(this.formName);
      if (!r) {
        this.submit = false;
        return;
      }

      try {
        const {confirmation} = this;
        await this.callback({confirmation});
        this.show = false;
      } catch (e) {
        console.error('ModalOTP.onSubmit');

        const eMsg = catchDispatchErrorMsg.call(this, e).toLowerCase();
        if (eMsg.includes('messaggio_otp')) {
          this.confirmation = '';
        }

        catchDispatch.call(this, e);
      } finally {
        this.submit = false;
      }
    },
  },
};
</script>
